import { render } from "./TranslationProgress.vue?vue&type=template&id=68a43b74"
import script from "./TranslationProgress.vue?vue&type=script&lang=js"
export * from "./TranslationProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__